import { BALANCES_STRINGS } from "./constants/strings";

import { IntegrationComponent } from "components/IntegrationComponent";
import { MainContainer } from "components/MainContainer";

import BalancesTable from "./components/BalancesTable";

import { VACATION_STRINGS } from "shared/constants/vacationStrings";

const Balances = () => {
  return (
    <IntegrationComponent
      message={VACATION_STRINGS.INTEGRATION_MESSAGE}
      confirmButtonLabel={VACATION_STRINGS.INTEGRATION_CONFIRM_BUTTON_LABEL}
    >
      <MainContainer
        cancelTittle
        nameScreen={BALANCES_STRINGS.TITLE}
        dataTestId="balances-main-container"
        alertComponent={null}
      >
        <div className="flex w-full h-full justify-center items-center content-center relative border rounded-md shadow-2xl p-1">
          <BalancesTable />
        </div>
      </MainContainer>
    </IntegrationComponent>
  );
};

export default Balances;
